import React, { ReactNode, useEffect, useState } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { I18nextProvider } from 'react-i18next';
import { ConfigProvider, App as AntApp, theme as antdTheme } from 'antd';
import { AuthProvider } from '~/app/auth/context/AuthContext';
import {
  antdConfigProviderModal,
  antdConfigProviderTheme,
} from './theme/antd-theme';
import { i18n } from '~/app/i18n';
import { initializeApiClient } from './lib/api-config';

export function Providers({ children }: { children: ReactNode }) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 60_000, // 1 minute
            refetchOnWindowFocus: false,
          },
        },
      }),
  );

  useEffect(() => {
    // Initialize API client configuration
    initializeApiClient();

    const locale = localStorage.getItem('language') || 'en';
    document.documentElement.lang = locale;
    if (i18n.language !== locale) i18n.changeLanguage(locale);
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <ReactQueryDevtools initialIsOpen={false} />
      <I18nextProvider i18n={i18n}>
        <ConfigProvider
          theme={{
            algorithm: antdTheme.defaultAlgorithm,
            ...antdConfigProviderTheme,
          }}
          modal={antdConfigProviderModal}
        >
          <AntApp>
            <AuthProvider>{children}</AuthProvider>
          </AntApp>
        </ConfigProvider>
      </I18nextProvider>
    </QueryClientProvider>
  );
}
